import React from "react";
import { withTheme } from "styled-components";
import store from "../../reducers";

const WelcomeHeaderText = (props)=>{
	const { organization: { organization: { name } } } = store.getState();
	return (<div style={{ fontSize: 38, textAlign: "center", margin: "40px 0 40px 0" }}>
        Welcome<span style={{ color:props.theme.mainColor }}>{`, ${name}`}</span>
	</div>);
};
export default withTheme(WelcomeHeaderText);


// WEBPACK FOOTER //
// ./src/components/text/WelcomeText.js